import { Box, SxProps } from "@mui/material";

export default function NASLogo({ sx }: { sx?: SxProps }) {
  return (
    <Box sx={sx}>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 143.4 44.6"
        xmlSpace="preserve"
      >
        <g>
          <polygon
            fill="#ffffff"
            points="22.1,25.2 6.7,4.9 0,4.9 0,37.9 7.1,37.9 7.1,17 23.1,37.9 29.3,37.9 29.3,4.9 22.1,4.9 	"
          />
          <polygon fill="#ffffff" points="69.7,4.8 55.5,38 62.9,38 72.9,13.5 82.9,38 90.5,38 76.3,4.8 	" />
          <path
            fill="#ffffff"
            d="M132.8,18.2c-5.7-1.5-7.1-2.2-7.1-4.3v-0.1c0-1.6,1.5-2.9,4.2-2.9c2.7,0,5.7,1.2,8.6,3.2l3.8-5.5 c-3.3-2.7-7.4-4.2-12.2-4.2c-6.7,0-11.5,4-11.5,9.9v0.1c0,6.6,4.3,8.4,10.9,10.1c5.5,1.4,6.6,2.4,6.6,4.2v0.1 c0,1.9-1.8,3.1-4.7,3.1c-3.8,0-6.9-1.6-9.8-4l-4.3,5.1c4,3.5,9,5.3,14,5.3c7.1,0,12.1-3.7,12.1-10.2V28 C143.2,22.3,139.4,19.9,132.8,18.2z"
          />
          <rect x="43.3" fill="#ffffff" width="0.9" height="44.6" />
          <rect x="102.9" fill="#ffffff" width="0.9" height="44.6" />
        </g>
      </svg>
    </Box>
  );
}
